<template>
  <div class="text-center">
    <component :is="icon" class="mx-auto h-12 w-12 text-gray-400 light-icon" />
    <!-- <h3 class="mt-2 text-sm font-medium text-gray-900">No projects</h3> -->
    <p class="mt-1 text-sm text-gray-500">
      {{ title }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'Empty',
  props: {
    icon: {
      type: String,
      default: 'InboxIcon',
    },
    title: {
      type: String,
      default: 'Rien à afficher',
    },
  },
}
</script>

<style>
.light-icon path {
  stroke-width: 1;
}
</style>
